<template>
  <div class="screening">
    <!-- 分类列表 -->
    <div class="typelist">
      <div class="inner" v-loading="fullscreenLoading">
        <!-- 全部结果 -->
        <div class="typela seltagall" v-if="taglist.length > 0">
          <div class="htitle">
            <h3>全部结果</h3>
          </div>
          <div class="tagsel typetxtl">
            <el-tag
              v-for="(item, key) in taglist"
              :key="item.titleB"
              class="eltags"
              type="warning"
              closable
              @close="handleClose(item, key)"
            >
              {{ item.titleB }}
            </el-tag>
          </div>
        </div>
        <!-- 专业大类 -->
        <div class="typela" v-for="(item, key) in navlist" :key="key">
          <div class="htitle" v-if="taglist.length == 0">
            <h3>资源类型：</h3>
          </div>
          <div
            class="typetxtl"
            :class="item.flig == true ? '' : 'typetwo'"
            v-if="taglist.length == 0"
          >
            <span
              v-for="(itemb, keyb) in item.children"
              :key="keyb"
              :class="itemb.type == 1 ? 'spanlist' : ''"
              @click="sptxtsel(itemb, 0)"
              >{{ itemb.type == 1 ? itemb.name : "" }}</span
            >
          </div>

          <span
            v-if="item.children.length > 6 && taglist.length == 0"
            class="setupas"
            @click="setopen(item, key)"
          >
            <i
              :class="[
                'insetupas',
                'el-icon-caret-bottom',
                item.flig == false ? '' : 'myrotate',
              ]"
            ></i>
          </span>
        </div>
        <!-- 媒体类型 -->
        <div class="typela">
          <div class="htitle">
            <h3>媒体类型：</h3>
          </div>
          <div class="typetxtl">
            <span
              v-for="(item, key) in mediaTypeOptions"
              :key="key"
              class="spanlist"
              :class="mediacss == true && mediaType == item.index ? 'selcssa' : ''"
              @click="meditsel(item, key)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <!-- 筛选条件 -->
        <div class="condition" v-show="prdshow">
          <span class="paixulist">排序方式</span>
          <div class="radiolist">
            <el-radio-group v-model="radio" @change="radiochange">
              <el-radio :label="0">默认</el-radio>
              <el-radio :label="1">点赞量</el-radio>
              <el-radio :label="2">点击量</el-radio>
              <el-radio :label="3">收藏量</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 删除指定的数组元素---扩展方法
Array.prototype.arrindex = function (val) {
  for (let index = 0; index < this.length; index++) {
    if (this[index] == val) {
      return index;
    }
  }
  return -1;
};
Array.prototype.remove = function (val) {
  var index = this.arrindex(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
import { webList, getTypes } from "@/api/library";
export default {
  name: "screening",
  data() {
    return {
      typelista: [{ title: "全部", selstatus: true }], //全部类
      showsp: true,
      opentxt: "展开",
      selcss: 0,
      mediacss: true, //媒体类型css
      samplecss: true, //其他类型
      baseurl: process.env.VUE_APP_BASE_API,
      radio: 0, //排序方式
      typeobj: {},
      mediaTypeOptions: [], //媒体类型
      mediaType: "", //媒体类型传参
      sortName: "", //排序
      fullscreenLoading: false, //页面的loading
      settimeall: null, //延迟器
      seldatalls: [], //多选---大类下的ID
      taglist: [],
      checkedCities: [], //check
      selectBigId: [], //多选---大类ID
      prdshow: false,
      inpseach: "", //搜索专业类
      keysearch: null, //搜索时记录key
      keyselradio: null, //点击展开记录key
      typesselitem: {}, //筛选数据
    };
  },
  props: ["navlist", "typessel"],
  mounted() {
    if (this.$route.path == "/") {
      this.prdshow = true;
    } else {
      this.prdshow = false;
    }
    this.getMediaTypes(); //媒体类型
    this.homrousel(); // 从首页来特殊创新案例
  },
  watch: {
    navlist: {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (oldValue.length > 0) {
          if (newValue[0].id !== oldValue[0].id) {
            this.classlist(newValue);
            this.canReset();
          }
        }
        this.homrousel(); // 从首页来特殊创新案例
      },
    },
  },
  methods: {
    // 从首页来特殊创新案例
    homrousel() {
      this.$nextTick(() => {
        if (this.$route.query.homeselId) {
          //筛选出来当前tab栏
          if (this.navlist && this.navlist.length > 0) {
            let tagItem = this.navlist[0].children.filter((el) => {
              return this.$route.query.homeselId == el.id;
            });
            this.sptxtsel(tagItem[0], 0);
          }
        }
      });
    },
    classlist(item) {
      this.navlist = item;
      this.getMediaTypes(); //媒体类型
    },
    classweblist() {
      this.fullscreenLoading = true;
      let selectBigId = [...new Set([...this.selectBigId])];
      // 类型列表
      webList({ selectId: this.seldatalls, selectBigId: selectBigId })
        .then((res) => {
          if (res.code == 200) {
            this.typelistall = res.rows;
            this.typelistalltwo = JSON.parse(JSON.stringify(res.rows));
            this.typelistall.forEach((val, key) => {
              let objkey = "big" + val.id;
              this.typessel[objkey] = [];
              this.$set(val, "flig", false);
              val.children = [...val.children];
            });
            //从专题网点击比如 大赛模板 跳转过来
            let datasa = this.$route.query;
            if (datasa.xiaolei) {
              let xlobj;
              let dlobj = this.typelistall.filter((el) => {
                if (Number(datasa.dalei) === el.id) {
                  xlobj = el.children.filter((val) => {
                    return Number(datasa.xiaolei) === val.id;
                  });
                  return el;
                }
              });
              if (dlobj.length > 0 && xlobj.length > 0) {
                this.sptxtsel(...xlobj, ...dlobj);
              }

              this.$router.push({ path: "/" });
            }
          } else {
          }
          this.fullscreenLoading = false;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    //媒体类型
    getMediaTypes() {
      this.mediaTypeOptions = [];
      this.mediaType = "";
      getTypes().then((res) => {
        if (res.code == 200) {
          let selmedall = [{ name: "全部", index: "" }];
          this.mediaTypeOptions = selmedall.concat(res.data);
        }
      });
    },
    meditsel(item) {
      this.mediacss = true;
      this.mediaType = item.index;
      if (this.taglist.length == 0) {
        this.$emit("pagedata", { page: 1, mediaType: this.mediaType, tagNum: 0 });
      } else {
        this.$emit("pagedata", { page: 1, mediaType: this.mediaType, tagNum: 1 });
      }
    },

    // 排序方式
    radiochange(val) {
      this.radio = val;
      switch (this.radio) {
        case 0:
          this.sortName = "";
          break;
        case 1:
          this.sortName = "pros";
          break;
        case 2:
          this.sortName = "clicks";
          break;
        case 3:
          this.sortName = "collectedCount";
          break;
        case 4:
          this.sortName = "downloads";
          break;
        default:
          break;
      }
      this.$emit("pagedata", { page: 1, sortName: this.sortName });
    },
    // 展开折叠
    setopen(item) {
      item.flig = !item.flig;
    },
    //专业类筛选
    sptxtsel(itemb, status) {
      //status  0代表用户点击筛选栏  1代表点击的是tab下拉菜单
      if (this.seldatalls.indexOf(itemb.id) > -1) {
        if (status == 0) {
          this.$message({
            message: "请不要重复添加",
            type: "warning",
          });
        }
        return;
      }

      let arrreslu = [];
      for (let index = 0; index < this.taglist.length; index++) {
        let tyinds = this.taglist[index].types;
        if (tyinds.length > 0) {
          for (let index2 = 0; index2 < tyinds.length; index2++) {
            arrreslu.push(tyinds[index2]);
          }
        }
      }
      let types = [...arrreslu, ...itemb.types];
      let smallId = [];

      for (let index = 0; index < types.length; index++) {
        let keysel = "big" + types[index].typeBigId;
        smallId.push(types[index].typeSmallId + "-" + keysel);
        this.typesselitem[keysel] = [];
      }
      for (let index = 0; index < smallId.length; index++) {
        let splitarr = smallId[index].split("-");
        this.typesselitem[splitarr[1]].push(splitarr[0]);
      }
      // ...this.typessel,
      this.typesselitem = { ...this.typesselitem };
      //查子集
      if (itemb.children.length > 0) {
        
        // 标签
        this.taglist.push({
          idB: itemb.id,
          titleB: itemb.name,
          types: itemb.types,
          fastatus: true,
        });
        this.$emit("seldata", { dataitem: itemb, status: false });
      } else {
        // 标签
        this.taglist.push({
          idB: itemb.id,
          titleB: itemb.name,
          types: itemb.types,
          fastatus: false,
        });
      }
      this.seldatalls.push(itemb.id);
      
      if (status == 0) {
        this.$emit("pagedata", { page: 1, typessel: this.typesselitem });
      }
    },
    // 删除tag标签
    handleClose(tag) {
      let types = tag.types;
      for (let index = 0; index < types.length; index++) {
        let keysel = "big" + types[index].typeBigId;
        let smallId = types[index].typeSmallId + "";
        //es搜索参数
        let arrIndex = this.typesselitem[keysel].indexOf(smallId);
        this.typesselitem[keysel].splice(arrIndex, 1);
      }

      //webList分类参数
      this.seldatalls.splice(this.seldatalls.indexOf(tag.idB), 1);

      // tag参数
      if (tag.fastatus) {
        this.$emit("seldata", { dataitem: this.navlist, status: true });
      }

      this.taglist.splice(this.taglist.indexOf(tag), 1);

      if (this.taglist.length == 0) {
        this.$emit("pagedata", { page: 1, tagId: tag.idB, tagNum: 0 });
      } else {
        this.$emit("pagedata", { page: 1, typessel: this.typesselitem, tagId: tag.idB });
      }
    },
    //重置参数
    canReset() {
      this.taglist = [];
      this.typesselitem = {};
      this.sortName = "";
      this.seldatalls = [];
      this.selectBigId = [];
    },
    seltab(data) {
      if (data.length > 0) {
        this.sptxtsel(data[0], 1);
      } else {
        this.taglist = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.screening {
  margin-top: 40px;
}
.typelist {
  width: 100%;
}
.typela {
  width: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
}
.typela:nth-child(1) {
  border-top: 1px solid #f5f5f5;
}
.htitle {
  width: 90px;
  padding: 0 5px;
  line-height: 38px;
  overflow: hidden;
  color: #666666;
  h3 {
    font-size: 16px;
  }
}
.typetxtl {
  flex: 1;
  margin-top: 5px;
  overflow: hidden;
  padding-right: 30px;
}
// 多选
.typetxtlkey {
  flex: 1;
  padding: 5px 15px;
}
.check_item {
  margin-top: 10px;
}
/* 折叠状态 */
.typetwo {
  height: 29px;
  overflow: hidden;
}
.typetxtl span {
  font-size: 15px;
  margin-bottom: 5px;
  border: 1px solid #fff;
}
.spanlist {
  display: inline-block;
  line-height: 25px;
  vertical-align: middle;
  margin: 0 5px;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 16px;
  color: #333333;
  transition: all 0.2s;
}
.spanlist:hover {
  color: #f78a1a;
}
.setupas {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 19px;
  font-size: 16px;
  cursor: pointer;
  margin: 8px 5px 0 0;
  transition: all 0.2s;
  color: #333333;
  i {
    margin-left: 1px;
  }
  .insetupas {
    transition: all 0.3s;
    &.myrotate {
      transform: rotate(180deg);
    }
  }
}
.setupas:hover {
  color: #f78a1a;
}
/* 选中后的样式 */
.selcssa {
  color: #f78a1a;
}
/* 筛选 */
.condition {
  height: 50px;
  background-color: #f5f5f5;
  display: flex;
  line-height: 50px;
  padding: 0 30px;
  margin: 0 auto;
  margin-top: 10px;
}
.paixulist {
  font-size: 15px;
  color: #606266;
}
.radiolist {
  margin-left: 20px;
}
// 选中后的标签展示
.seltagall {
  .tagsel {
    padding: 0 15px;
    .eltags {
      background-color: #ffffff;
      color: #f78a1a;
      border: none;
      border-radius: 16px;
    }
    span {
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
.radiolist {
  margin-left: 10px;
  float: left;
  /* 选中后的字体颜色 */
  .el-radio__input.is-checked + .el-radio__label {
    color: #f78a1a !important;
  }
  /* 选中后小圆点的颜色 */
  .el-radio__input.is-checked .el-radio__inner {
    background: #f78a1a !important;
    border-color: #f78a1a !important;
  }
}
</style>
